export function trimText(text: string, length: number, suffix = '...'): string {
  if (text.length > length) {
    const _trimmed = text.substring(0, length - 1);
    return `${_trimmed}${suffix}`;
  }
  return text;
}
